import React, { Component } from 'react';
/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showPreferenceModal } from '../../redux/actions/preferenceModalActions';

const mapDispatchToProps = {
    showPreferenceModal
};

class NavBarMobileView extends Component {
    constructor(props) {
        super(props);
        this.mobileViewRef = React.createRef();
        this.handleMobileMenuClickOutside = this.handleMobileMenuClickOutside.bind(this);
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleMobileMenuClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleMobileMenuClickOutside);
    }

    handleMobileMenuClickOutside(event) {
        if (this.mobileViewRef && !this.mobileViewRef.current.contains(event.target)) {
            this.toggleMobileView();
        }
    }

    toggleMobileView() {
        document.removeEventListener('click', this.handleMobileMenuClickOutside);
        document.getElementById("nav-bar-mobile-view").style.display = "none";
    };

    launchChanger() {
        let body = {
            show: true
        }
        this.props.showPreferenceModal(body);
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.type === 'user' ?
                        <div id='nav-bar-mobile-view' className="menu_div hide-on-desktop" style={{ display: this.props.visible ? '' : 'none' }} ref={this.mobileViewRef}>
                            <ul>
                                <li id="active"><a href="#"></a></li>
                                <li onClick={(e) => { (this.props.userDetails.isGuest === false) && (window.location.href = "/myaccount") }}><i className="fas fa-user" /><a href="#">{this.props.userDetails.customerName}</a></li>
                                <li onClick={() => { this.launchChanger() }}> <i className="fas fa-map-marker-alt" /><a href="#">{this.props.shoppingPreference.outletName}</a></li>
                                <li onClick={() => { this.launchChanger() }}> <i className="fas fa-truck" /><a href="#">{this.props.shoppingPreference.shoppingMethod}</a></li>
                                <li onClick={() => { window.location.href = ("/welcome/TrackOrder") }}> <i className="fas fa-truck" /><a href="#">Track My Order</a></li>
                                {
                                    this.props.userDetails.isGuest ?
                                        <li onClick={this.props.login}> <i className="fas fa-sign-out-alt" /><a href="#">Signup | Login</a></li>
                                        : <li onClick={this.props.logout}> <i className="fas fa-sign-out-alt" /><a href="#">Log out</a></li>
                                }

                            </ul>
                        </div>
                        :
                        <div id='nav-bar-mobile-view' className="menu_div hide-on-desktop" style={{ display: this.props.visible ? '' : 'none' }} ref={this.mobileViewRef}>
                            <ul>
                                <li id="active"><a href="#"></a></li>
                                <li onClick={() => { window.location.href = '/'; }}><a >Home</a></li>
                                {/* <li onClick={() => { window.location.href = '/showcaseint/items/hamper'; }}><a >Hampers</a></li> */}
                                <li onClick={() => { window.location.href = '/showcaseint/items/keells_products'; }}><a >Keells Products</a></li>
                                <li onClick={() => { window.location.href = '/showcaseint/items/keells_exclusives'; }}><a >Keells Exclusives</a></li>
                                <li onClick={() => { window.location.href = "keells-promotions"; }}><a>All Promotions</a></li>
                                {/* <li onClick={() => { window.location.href = "/product/6"; }}><a>Catalogues & Deals</a></li> */}
                                {/* <li onClick={() => { window.location.href = "/showcaseint/christmas_2021?utm_source=internal_website&utm_medium=site_header&utm_campaign=christmas_2021"; }}><a>Seasonal Specials</a></li> */}
                                <li onClick={() => { window.location.href = "/store-locator"; }}><a>Stores</a></li>
                                <li onClick={() => { window.location.href = "/contactUs"; }}><a>Contact us</a></li>
                                <li onClick={() => { window.location.href = '/utility-bill-payment'; }}><a>Utility Bill Payment</a></li>
                                <li onClick={() => { window.location.href = '/keells-community'; }}><a>Community</a></li>

                            </ul>
                        </div>
                }
            </React.Fragment>
        );
    }
}
export default connect(null, mapDispatchToProps, null, { forwardRef: true })(NavBarMobileView);
